// more alert types here: https://tailwindui.com/components/application-ui/feedback/alerts

export function GreenAlert(props: { children: React.ReactNode }) {
  return (
    <div className="rounded-md bg-green-50 p-4">
      <h3 className="text-sm font-medium text-green-800">{props.children}</h3>
    </div>
  );
}

export function RedAlert(props: { children: React.ReactNode }) {
  return (
    <div className="rounded-md bg-red-50 p-4">
      <h3 className="text-sm font-medium text-red-800">{props.children}</h3>
    </div>
  );
}

export function YellowAlert(props: { children: React.ReactNode }) {
  return (
    <div className="rounded-md bg-yellow-50 p-4">
      <h3 className="text-sm font-medium text-yellow-800">{props.children}</h3>
    </div>
  );
}

export function Alert(props: { children: React.ReactNode; color: 'green' | 'red' | 'yellow' }) {
  if (props.color === 'green') return <GreenAlert {...props} />;
  if (props.color === 'red') return <RedAlert {...props} />;
  if (props.color === 'yellow') return <YellowAlert {...props} />;

  return <GreenAlert {...props} />;
}
